<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <v-card class="elevation-10">
          <v-toolbar :color="'primary white--text'">
            <v-spacer></v-spacer>
            <v-toolbar-title>
                Editar Projeto de Pesquisa {{projetoPesquisa.numRegistro === null || projetoPesquisa.numRegistro === '' ? '' : 'nº ' + projetoPesquisa.numRegistro + ' '}} - {{projetoPesquisa.titulo}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
              <v-tabs
                centered
                show-arrows
                dark
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
                color="primary"
                hide-slider
                slot="extension">

                <!-- Aba "Informações Básicas" -->
                <router-link class="router_disable" exact :to="{name: 'EditarProjetoPesquisaInformacoesBasicas'}" tag="v-tab">Informações Básicas</router-link>

                <!-- Aba "Detalhamento" -->
                <router-link class="router_disable" exact :to="{name: 'EditarProjetoPesquisaDetalhamento'}" tag="v-tab">Detalhamento</router-link>

                <!-- Aba "Instituições" -->
                <router-link class="router_disable" exact :to="{name: 'ProjetoPesquisaInstituicoes'}" tag="v-tab">Instituições</router-link>

                <!-- Aba "Equipe" -->
                <router-link class="router_disable" exact :to="{name: 'ProjetoPesquisaEquipe'}" tag="v-tab">Equipe</router-link>

                <!-- Aba "Órgãos Financiadores" -->
                <router-link class="router_disable" exact :to="{name: 'ProjetoPesquisaOrgaosFinanciadores'}" tag="v-tab">Órgãos Financiadores</router-link>

                <!-- Aba "Arquivos" -->
                <router-link class="router_disable" exact :to="{name: 'ProjetoPesquisaArquivos'}" tag="v-tab">Arquivos</router-link>

                <!-- Aba "Outras Informações" -->
                <router-link class="router_disable" exact :to="{name: 'EditarProjetoPesquisaOutrasInformacoes'}" tag="v-tab">Outras Informações</router-link>

                <!-- Aba "Contatos" -->
                <router-link class="router_disable" exact :to="{name: 'EditarProjetoPesquisaContatos'}" tag="v-tab">Contatos</router-link>

                <!-- Aba "Resultados Obtidos" -->
                <router-link v-if="habilitaAbaResultadosObtidos()" class="router_disable" exact :to="{name: 'EditarProjetoPesquisaResultadosObtidos'}" tag="v-tab">Resultados Obtidos</router-link>

              </v-tabs>

          </v-toolbar>
          <v-card-text>
            <router-view :idProjetoPesquisa="idProjetoPesquisa" :projetoPesquisa="this.projetoPesquisa"></router-view>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import projetos from '@/utils/projetos'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjetoPesquisa'],
  data: () => ({
    projetoPesquisa: {}
  }),
  computed: {
    ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'permissaoCriarProjetoExtensao'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']),

    // Verifica se o projeto de pesquisa está na situação "Em andamento".
    situacaoEmAndamento: function () {
      if (this.projetoPesquisa.situacao.item === 3) {
        return true
      } else {
        return false
      }
    },

    // Verifica se o projeto de pesquisa está na situação "Concluído".
    situacaoConcluido: function () {
      if (this.projetoPesquisa.situacao.item === 4) {
        return true
      } else {
        return false
      }
    },

    // Verifica se o projeto de pesquisa está na situação "Cancelado".
    situacaoCancelado: function () {
      if (this.projetoPesquisa.situacao.item === 5) {
        return true
      } else {
        return false
      }
    },

    // Habilita aba "Resultados Obtidos".
    habilitaAbaResultadosObtidos: function () {
      if (this.situacaoEmAndamento() || this.situacaoConcluido()) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    // Carrega o projeto de pesquisa.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' })
    projetos.getProjetoPesquisa(this.idProjetoPesquisa)
    .then(response => {
      this.projetoPesquisa = response.data
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar
  }
}
</script>

<style lang="css" scoped>
  .v-tab {
    margin-left: 0.5em;
    border-top-right-radius: 1em !important;
    border-top-left-radius: 1em !important;
    transform: perspective(25px) rotateX(2deg) !important;
    transform-origin: bottom !important;
    max-width: 12em !important;
    min-width: 4em !important;
  }
  .v-tab:not(.router-link-active) {
    color: #dddddd !important;
    background-color: #848484 !important;
  }
  .v-tab.router-link-active {
    color: black !important;
    background-color: white !important;
  }
  .v-tab >>> .tabs__container {
    transition: -webkit-transform .3s cubic-bezier(.86,0,.07,1);
    transition: transform .3s cubic-bezier(.86,0,.07,1);
  }
  .router_disable {
    pointer-events: none;
  }

  .titulo {
    color: white;
    text-align: justify;
    font-size: 14pt;
  }
</style>



// WEBPACK FOOTER //
// editar-projeto-pesquisa.vue?6cfa2835